export default __webpack_public_path__ + "static/hairwash4_coiffer-min-c96c6e5586b5df1ebd47a5439b433b98.png";